var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responsive-navbar-container"},[(_vm.visible)?_c('div',{staticClass:"responsive-navbar"},_vm._l((_vm.navItems),function(item,index){return _c('div',{key:index},[_c('router-link',{attrs:{"to":item.url},nativeOn:{"click":function($event){_vm.hideMenu($event)}}},[_vm._v(_vm._s(_vm.$t(("HEADER." + (item.name)))))])],1)})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8a2ae50","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/ResponsiveNav.vue
// module id = 916
// module chunks = 1